export default __webpack_public_path__ + "static/media/goalSuccess.b3c05a8d.png";